import { HttpClient } from "@angular/common/http";
import { Injectable,Injector } from "@angular/core";
import { DialogService } from "../shared/dialog/dialog.service";
import { BaseService } from "./base.service";

@Injectable()
export class TermsService extends BaseService {
    constructor(
        public httpClient: HttpClient,
        private dialog: DialogService,
        protected injectorObj:Injector
    ) {
        super(injectorObj)
    }

    async insuranceCheckTermsCondAcceptance(payload:any){
        this.logger.info(["insuranceCheckTermsCondAcceptance"]);
        return await this.post('/api/services/terms/insuranceCheckTermsCondAcceptance', payload)
    }

    async getTokenUrl(payload:any) {
        return await this.post('/api/services/terms/getTokenUrl', payload)
    }

    async verifyToken(payload:any) {
        return await this.post('/api/services/terms/verifyToken', payload)
    }

    async termsAndConditon(payload:any){
        return await this.post('/api/services/terms/termsAndConditon', payload)
    }

    async insuranceCreateUpdateTermsCondAcceptance(payload:any){
        return await this.post('/api/services/terms/insuranceCreateUpdateTermsCondAcceptance', payload)
    }


}
